import { render } from "./PreLaunch.vue?vue&type=template&id=12a04da0"
import script from "./PreLaunch.vue?vue&type=script&lang=js"
export * from "./PreLaunch.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__